import { render, staticRenderFns } from "./BaseBtnConfirm.vue?vue&type=template&id=b415fdfc&scoped=true&lang=pug"
import script from "./BaseBtnConfirm.vue?vue&type=script&lang=js"
export * from "./BaseBtnConfirm.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnConfirm.vue?vue&type=style&index=0&id=b415fdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b415fdfc",
  null
  
)

export default component.exports